import HttpApiCallError from '../errors/HttpApiCallError';
import 'whatwg-fetch';

export default async function asyncFetch(url, requestConfig = {}) {
  const response = await fetch(url, requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return await response;
  }

  const data = await response.json();

  throw new HttpApiCallError(
      data,
      data.error || response.statusText,
      response.status
  );
}



/** WEBPACK FOOTER **
 ** ./src/connectivity/async-fetch.js
 **/